export default __webpack_public_path__ + "static/Funding society_logo-b8d06a25c21e4fc0fa7d444b99895cd3.png";